import styled, { css } from 'styled-components'
import { font, spacing } from '@chegg-ui/theme'
import { SecondaryButton } from '@chegg/fanta'
import { ToastContainerProps } from './types'

/* if toast is not fixed, its assumed to be displayed inline in the component tree where its used */
const ToastFixedPosition = css`
  position: fixed;
  margin: ${spacing.px24};
`

export const ToastContainer = styled.div<ToastContainerProps>`
  z-index: 9999;
  min-width: 320px;
  box-shadow: 0 0 8px 0 rgba(34, 34, 34, 0.4);

  ${({ position }) => {
    switch (position) {
      case 'topLeft':
        return css`
          ${ToastFixedPosition}
          top: 0;
          left: 0;
        `
      case 'topRight':
        return css`
          ${ToastFixedPosition}
          top: 0;
          right: 0;
        `
      case 'bottomRight':
        return css`
          ${ToastFixedPosition}
          bottom: 0;
          right: 0;
        `
      case 'bottomLeft':
        return css`
          ${ToastFixedPosition}
          bottom: 0;
          left: 0;
        `
      case 'none':
      default:
        return `
          width: 100%;
        `
    }
  }}
`

export const ToastMessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ToastMessage = styled.div`
  font-size: ${font.size.px16};
  line-height: 22px;
`

export const CloseButton = styled(SecondaryButton)`
  display: flex;
  align-self: center;
  margin-left: ${spacing.px8};
  padding: 0;
  border: none;
`
